module.exports = __webpack_public_path__ + "img/108004.07044240.png";